import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '../../../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class CiCoreApiService {

  private readonly _apiUrl: string = environment.CiCoreApi;
  private readonly _tenantId: string = environment.tenantId;

  constructor(
    private _httpClient: HttpClient
  ) { }

  getGateways() {
    return this._httpClient.get(`${this._apiUrl}/api/v1/forwarder/public/gateways?tenantId=${this._tenantId}`);
  }
}
